"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = ['M19 5L19 6C19 6.093 18.994 6.184 18.982 6.273 18.994 6.347 19 6.423 19 6.5L19 16.5C19 17.328 18.328 18 17.5 18 16.672 18 16 17.328 16 16.5L15.999 10.111 7.675 18.275C7.068 18.869 6.098 18.869 5.492 18.275 4.9 17.695 4.891 16.746 5.471 16.155 5.478 16.148 5.485 16.141 5.492 16.134L13.786 7.999 7.5 8C6.672 8 6 7.328 6 6.5 6 5.672 6.672 5 7.5 5L17.499 4.999 19 5Z'];